<template>
  <div class="rpc_modal">
    <div class="header">
      <h4 class="title">
        RPC Info
      </h4>
    </div>
    <div class="content">
      <div class="command">
        <div class="command_item"  v-for="(command, key) in command_list" :key="key">
          <button class="btn-success btn-fill btn-wd marginButton" @click = "run_command(command)" >
            {{ command.name }}
          </button>
        </div>
      </div>
      <div class="history">
        <div v-if="load" class="load">
          <scale-loader />
        </div>
        <div id="terminal" class="terminal" ref="terminal"></div>
      </div>
    </div>

    <div class="footer">
      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>

</template>
<script>

import { Terminal } from 'xterm'
import 'xterm/css/xterm.css'
import { FitAddon } from "xterm-addon-fit"

export default {
  name: "RPC_Modal",
  props: ['fid', 'history', 'list'],
  data () {
    return {
      history_list: this.history,
      command_list: this.list,
      load: false
    }
  },
  mounted() {
    this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
    })

    let terminalContainer = document.getElementById('terminal')
    this.term = new Terminal({rows: 30, cols: 178, fontSize: 14})
    this.fitAddon = new FitAddon();
    this.term.open(terminalContainer)
    this.term._initialized = true
    this.term.loadAddon(this.fitAddon)

    this.term.onKey(e => {
      this.connection.send(JSON.stringify({ cmd: "run", data: e.key }))
    });

    for (let history of this.history_list) {
      this.term.write(this.get_date(history.ts))
      this.term.write('\r\n');
      this.term.write(history.in)
      this.term.write('\r\n');
      for (let i in history.out) {
        this.term.write(history.out[i])
        this.term.write('\r\n');
      }
      this.term.write('\r\n');
      this.term.write('\r\n');
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    check_command(id_command){
      this.interval = setInterval(() => {
        this.$http.v1.checkRPCCommand(id_command, (resp) => {
          if (resp.data.ts_end !== 0 && resp.data.status >= 5) {
            if (resp.data.out) {
              for (let i in resp.data.out) {
                this.term.scrollToBottom()
                this.term.write(resp.data.out[i])
                this.term.write('\r\n');
              }
            }else{
              this.global_notify('warning', this.translate('no_data'))
            }

            this.load = false
            clearInterval(this.interval)
          }
        })
      }, this.$store.getters.getCheckRpcCommand)
    },
    run_command(command){
      this.load = true
      this.$http.v1.runRPCCommand(this.fid, {rpc_id: command.id},(response) => {
        if (response.data.ts_end === 0) {
          this.term.write('\r\n');
          this.term.write(this.get_date(response.data.ts))
          this.term.write('\r\n');
          this.term.write(response.data.in)
          this.term.write('\r\n');

          this.check_command(response.data.id)
        }
      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .rpc_modal{
    padding: 10px;
    .header{
      padding: 10px 0;
      .title{
        font-size: 22px;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
    }
    .content{
      padding: 10px 0;
      .command{
        padding: 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        &_item{
          padding: 3px;
          button{
            margin: 0;
          }
        }
      }
      .history{
        position: relative;
        .terminal{
          width:100%;
          overflow-x: scroll;
          &::-webkit-scrollbar{
            width: 10px;
            height: 10px;
          }
        }
        .load{
          position: absolute;
          top: calc(50% - 30px);
          right: calc(50% - 30px);
          padding: 10px;
          width: 60px;
          height: 60px;
          z-index: 9;
          background-color: #ffffffbb;
          border-radius: 5px;
        }
      }
    }
    .footer{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .btn{
        margin: 0 5px;
        display: block;
      }
    }
  }

</style>
